/**
 * CustomerHeader Component
 *
 * Description: This component renders a header for the customer panel.
 *
 * File Name: CustomerHeader.tsx
 * Date: 06-08-2024
 */

import React, { useState, useEffect, useRef } from "react";
import HeaderNav from "./HeaderNav";
import ProfilePopup from "./ProfilePopup";
import defaultProfile from "src/assets/images/default_profile_image.png";
import logo from "src/assets/images/shifara-white-logo.png";
import { useSelector } from "react-redux";
import { Link, useNavigate, NavLink } from "react-router-dom";
import { RootState } from "@store/store";
import cartIcon from "src/assets/images/cart-white-icon.png";
import WebGlobalSearch from "src/Components/WebsiteComponents/WebGlobalSearch";
import dashboardPoint from "src/assets/images/dashboardPoint.png";
import AskAi from "../AskAI/AskAi";
import askAiIcon from "../../assets/images/AskAi/ask-ai-logo-dark.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { Modal } from "@mui/material";
import TavusAvatarExample from "../AskAI/TavusAvatarExample";
import MeetingConversion from "../AskAI/MeetingConversion";

const CustomerHeader: React.FC = () => {
  const navigate = useNavigate();
  const { pharmacyProducts } = useSelector(
    (store: RootState) => store.cartSlice
  );
  const { userDetails } = useSelector((store: RootState) => store.appReducer);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState<boolean>(false);
  const [isAskAiModalOpen, setIsAskAiModalOpen] = useState<boolean>(false);
  const buyRef = useRef<HTMLDivElement | null>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (buyRef.current && !buyRef.current.contains(event.target as Node)) {
      setIsProfileModalOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    setIsProfileModalOpen(false);
  }, [navigate]);
  const { totalItems } = useSelector((store: RootState) => store.cart);
  return (
    <>
      {/* <AskAi
        setIsAskAiModalOpen={setIsAskAiModalOpen}
        showModal={isAskAiModalOpen}
        userDetails={userDetails}
      /> */}
      {/* <button
        className="ask-ai-btn fixed bottom-0 right-0 m-4 font-size-14px font-Poppins-Medium rounded-full px-4 py-2"
        onClick={() => setIsAskAiModalOpen(true)}
      >
        <img src={askAiIcon} alt="magic-wound-icon" />
        <p className="font-size-18px">Ask AI</p>
      </button>
      {
        isAskAiModalOpen && (
          <Modal
            open={isAskAiModalOpen}
            onClose={() => setIsAskAiModalOpen(false)}
          >
            <MeetingConversion />
          </Modal>
        )
      } */}
      <header className="header fixed">
        <div className="view-area-width-2">
          {/* <div className="container-1480"> */}
          <div className="customer-header-inner flex items-center justify-between gap-5">
            <div className="header-left flex items-center flex-1">
              <div className="header-logo-container">
                <Link
                  to="/dashboard"
                  id="logo-home-link"
                  className="header-logo header-logo-img-react font-Poppins-SemiBold font-size-25px font-Poppins-Regular"
                >
                  <img src={logo} alt="" />
                </Link>
              </div>
              <div className="flex-1 ">
                {/* <WebGlobalSearch
                  context={"dashboard"}
                  style={{ width: "100%", maxWidth: "400px" }}
                  className="mx-0"
                  placeholder="Search "
                /> */}
              </div>
            </div>
            <div className="header-right">
              <HeaderNav />
              {/* <div className="flex gap-2 items-center">
                <img className="w-[32px]" src={dashboardPoint} alt="point" />
                <span className="flex flex-col">
                  <span className="font-Poppins-Medium text-[#ffd660] font-size-16px">
                    {userDetails?.creditPoints || 0}
                  </span>
                  <span className="font-Poppins-Medium text-white font-size-14px">
                    Care credit
                  </span>
                </span>
              </div> */}
              <div ref={buyRef}>
                <div
                  className="header-profile-container"
                  onClick={() => setIsProfileModalOpen(!isProfileModalOpen)}
                  id="avatar-label-icon"
                >
                  <img
                    alt="profile-image"
                    width={30}
                    height={30}
                    className="rounded-full header-profile-container-avater"
                    src={`${userDetails?.coverPhoto}?t=${Date.now()}`}
                    onError={(e) => {
                      const target = e.target as HTMLImageElement; // Assert the type
                      if (target) {
                        target.src = defaultProfile;
                      }
                    }}
                  />
                </div>
                <div className="avatar-label relative flex items-center gap-1">
                  <p
                    onClick={() => setIsProfileModalOpen(!isProfileModalOpen)}
                    style={{ cursor: "pointer" }}
                    id="avatar-label-text"
                    className="font-Poppins-Medium text-white font-size-14px capitalize"
                  >
                    {userDetails?.firstName || ""}
                  </p>
                  {/* <span
                    style={{ cursor: "pointer" }}
                    id="avatar-label-icon"
                    onClick={() => setIsProfileModalOpen(!isProfileModalOpen)}
                    className="text-white"
                  >
                    &#11206;
                  </span> */}
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    className="text-white font-size-12px cursor-pointer"
                    onClick={() => setIsProfileModalOpen(!isProfileModalOpen)}
                  />
                  <ProfilePopup
                    isProfileModalOpen={isProfileModalOpen}
                    setIsProfileModalOpen={setIsProfileModalOpen}
                  />
                </div>
              </div>
              {/* <div>
                <NavLink
                  to="/customer/pharmacy-cart"
                  className="header-nav-items header-nav-items-bell-icon font-size-15px font-Poppins-Regular"
                  style={{ cursor: "pointer" }}
                >
                  <div className="relative">
                    <img
                      style={{
                        filter:
                          "grayscale(100%) brightness(600%) contrast(100%) sepia(100%) hue-rotate(-90deg)",
                      }}
                      src={cartIcon}
                      alt=""
                      width={20}
                      height={20}
                    />
                    {pharmacyProducts?.length ? (
                      <span className="cart-count-total font-size-11px text-white font-Poppins-SemiBold">
                        {pharmacyProducts?.length || 0}
                      </span>
                    ) : null}
                    {totalItems ? (
                      <span className="cart-count-total font-size-11px text-white font-Poppins-SemiBold">
                        {totalItems}
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                  <p className="font-size-14px font-Poppins-Medium">Cart</p>
                </NavLink>
              </div> */}
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default CustomerHeader;
